import React from 'react';
import PropTypes from 'prop-types';
import { useLeagueSettings } from '../../context/LeagueSettingsContext';
import HiddenText from '../HiddenText';
import styles from './styles/scheduled.module.css';

const BettingButton = ({
  pickType,
  displayValue,
  isWatched,
  isLocked,
  isOtherLocked,
  hasReachedMaxPicks,
  hasRecentLineChange,
  isDisabled,
  isLoading,
  onClick,
  onKeyDown,
  ariaLabel,
    weekNumber,
  hasUserReachedMaxLocks
}) => {
  const { canSeeLocks } = useLeagueSettings();

  // Show hidden text for locked picks if locks are hidden AND user hasn't reached max locks
  // Only hide the lock details, not the username (which is handled elsewhere)
  const shouldHideLock = isLocked && !canSeeLocks() && !hasUserReachedMaxLocks;

  return (
    <button
      className={`${styles.betButton}
        ${isWatched ? styles.selected : ''}
        ${isLocked ? styles.locked : ''}
        ${isOtherLocked ? styles.otherLocked : ''}
        ${hasReachedMaxPicks && !isLocked && !isOtherLocked ? styles.maxReached : ''}
        ${hasRecentLineChange ? styles.lineChanged : ''}
        ${isDisabled ? styles.disabled : ''}`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      disabled={isLoading ||
                isOtherLocked ||
                isLocked ||
                (hasReachedMaxPicks && !isLocked) ||
                isDisabled}
      aria-busy={isLoading}
      aria-label={ariaLabel}
    >
      {isLoading ? 'Loading...' : (
        shouldHideLock ? (
          <HiddenText
            type="lock"
            weekNumber={weekNumber}
            showTooltip={true}
          />
        ) : (
          displayValue
        )
      )}
    </button>
  );
};

BettingButton.propTypes = {
  pickType: PropTypes.oneOf(['home', 'away', 'over', 'under']).isRequired,
  displayValue: PropTypes.string.isRequired,
  isWatched: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isOtherLocked: PropTypes.bool.isRequired,
  hasReachedMaxPicks: PropTypes.bool.isRequired,
  hasRecentLineChange: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  weekNumber: PropTypes.number,
  hasUserReachedMaxLocks: PropTypes.bool
};

export default BettingButton;
